import {
  IModuleConnect,
  IModulePayload,
  IPdfPayload,
  IVideoPayload,
} from "../../types";
import { request } from "../../utils/axios";

export const connectModule = async (form: IModuleConnect, moduleID: number) => {
  try {
    const res = await request.post(`admin/modules/${moduleID}/content-items`, {
      ...form,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const createModule = async (form: IModulePayload, CourseID: number) => {
  try {
    const res = await request.post(`admin/modules`, {
      ...form,
      order: 1,
      course_id: CourseID,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateModule = async (form: IModulePayload) => {
  try {
    const res = await request.put(`admin/modules/${form.ID}`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchModule = async ({
  CourseID,
  ID,
}: {
  CourseID: number;
  ID: number;
}) => {
  try {
    const res = await request.get(`admin/courses/${CourseID}/module/${ID}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteModule = async (id: string | number) => {
  try {
    const res = await request.delete(`admin/modules/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteContentItem = async (id: number) => {
  try {
    const res = await request.delete(`admin/content-items/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

//VIDEO

export const createVideo = async ({
  title,
  description,
  duration,
  minWatchPercent,
  youtubeURL,
}: IVideoPayload) => {
  try {
    const res = await request.post(`admin/videos`, {
      title,
      description,
      duration,
      minWatchPercent,
      youtubeURL,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updateVideo = async ({
  id,
  title,
  description,
  duration,
  minWatchPercent,
  youtubeURL,
}: IVideoPayload) => {
  try {
    const res = await request.put(`admin/videos/${id}`, {
      title,
      description,
      duration,
      minWatchPercent,
      youtubeURL,
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchVideo = async (page = 1) => {
  try {
    const res = await request.get(`admin/videos?page=${page}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deleteVideo = async (id: number) => {
  try {
    const res = await request.delete(`admin/videos/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

//PDF

export const createPDF = async ({ title, file }: IPdfPayload) => {
  try {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("file", file);

    const res = await request.post(`admin/pdfs`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const updatePDF = async ({ title, file, id }: IPdfPayload) => {
  try {
    const fd = new FormData();
    fd.append("title", title);
    fd.append("file", file);

    const res = await request.post(`admin/pdfs/${id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchPDF = async (page = 1) => {
  try {
    const res = await request.get(`admin/pdfs?page=${page}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const fetchSinglePDF = async () => {
  try {
    const res = await request.get(`admin/pdfs/:pdfId`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const deletePDF = async (id: number) => {
  try {
    const res = await request.delete(`admin/pdfs/${id}`);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
